import { ComboboxOption as BaseComboboxOption } from '@reach/combobox'

import { styled } from '~/styled'

export const ComboboxOption = styled(BaseComboboxOption, {
  base: [
    'text-grey-900',
    'cursor-pointer',
    'm-0',
    'p-2',
    'hover:bg-grey-100',
    'hover:rounded-sm',
    'aria-selected:bg-grey-100',
    'aria-selected:rounded-sm',
    'data-user-value:text-primary-800'
  ]
})
